import { Breadcrumb, Col, Row, Space, Typography } from "antd";
import React from "react";
import PageHeader from "../../components/Elements/PageHeader";
import { FileAddOutlined } from "@ant-design/icons";
import CreationForm from "./Create/CreationForm";

const { Link } = Typography;

export default function CreateInvoice() {
  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <Space direction="vertical">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: <Link href="/invoices/all-invoices">All Invoices</Link>,
                },
                {
                  title: <Link href="/invoices/create-invoice">Create Invoice</Link>,
                },
              ]}
            />
            <PageHeader text="Create Document" icon={<FileAddOutlined />} />
          </Space>
        </Col>
        <Col span={24}>
          <CreationForm />
        </Col>
      </Row>
    </div>
  );
}
